(() => {
  const productInfo = document.querySelector('product-info');
  const legacyContactQuoteLinks = Array.from(document.querySelectorAll('a[href*="/pages/contact"]')).filter((link) =>
    /\b(?:delivery|freight)\s+quote\b|request\s+(?:a\s+)?(?:freight\s+)?quote\b/i.test(link.textContent)
  );
  const quoteLinks = [
    ...new Set([
      ...document.querySelectorAll('[data-delivery-quote-link], a[href="#modal"]'),
      ...legacyContactQuoteLinks,
    ]),
  ];

  if (!productInfo || !quoteLinks.length) return;

  const updateQuoteLink = (link, variant) => {
    const params = new URLSearchParams({
      product: link.dataset.deliveryQuoteProduct || productInfo.dataset.productTitle,
      variant: variant?.title || '',
      product_url: window.location.href,
    });

    link.href = `${link.dataset.deliveryQuoteUrl || '/pages/delivery'}?${params.toString()}`;
  };

  const selectedVariantMarkup = productInfo.querySelector('variant-selects [data-selected-variant]')?.textContent;
  let selectedVariant;

  try {
    selectedVariant = selectedVariantMarkup ? JSON.parse(selectedVariantMarkup) : undefined;
  } catch (_) {
    selectedVariant = undefined;
  }

  quoteLinks.forEach((link) => updateQuoteLink(link, selectedVariant));

  document.addEventListener('variant:change', ({ detail }) => {
    const variant = detail?.variant;
    if (!variant) return;

    quoteLinks.forEach((link) => updateQuoteLink(link, variant));
  });
})();
